import UserModel from 'models/UserModel';

UserStore.dispatchToken = MakeShiftEmployeeDispatcher.register(UserStore.dispatchCallback);
UserStore.location = [];
UserStore.department = [];

UserStore.onDepartmentHandler = function (deptData, response) {
  if (_.isEmpty(UserStore.getDepartmentById(deptData.models[0].attributes.id))) {
    UserStore.department.push(deptData.models[0].present());
  }
  UserStore.trigger('user:department:load:success', deptData.models[0].present());
};

UserStore.onDepartmentError = function (error) {
  UserStore.trigger('user:department:load:error');
};

UserStore.getDepartment = function () {
  let data = {};
  this.models.map((d) => {
    if (d.attributes.data.department) {
      data = d.attributes.data.department;
    }
  });
  return data;
};

UserStore.onLocationHandler = function (locData, response) {
  if (_.isEmpty(UserStore.getLocationById(locData.models[0].attributes.id))) {
    UserStore.location.push(locData.models[0].present());
  }
  UserStore.trigger('user:location:load:success', locData.models[0].present());
};

UserStore.onLocationError = function (error) {
  UserStore.trigger('user:location:load:error');
};

UserStore.getLocationById = function (id) {
  let data = {};
  if (!_.isEmpty(UserStore.location)) {
    UserStore.location.map((location) => {
      if (location.id && parseInt(location.id, 10) === parseInt(id, 10)) {
        data = location;
      }
    });
  }
  return data;
};

UserStore.getDepartmentById = function (id) {
  let data = {};
  if (!_.isEmpty(UserStore.department)) {
    UserStore.department.map((dept) => {
      if (dept.id && parseInt(dept.id, 10) === parseInt(id, 10)) {
        data = dept;
      }
    });
  }
  return data;
};

UserStore.onUserHandler = function (userData, response) {
  const user = new UserModel(response);
  UserStore.add(user);
  UserStore.trigger('user:load:success', response);
};

UserStore.onUserError = function (error) {
  console.log(JSON.stringify(error));
};

UserStore.onSharedCalendarHandler = function (userData, response) {
  UserStore.calandarShare = response;
  UserStore.trigger('user:shared:calendar:success', response);
};

UserStore.onSharedCalendarError = function (error) {
  UserStore.trigger('user:shared:calendar:error', error);
};

UserStore.onSharedCalendarRemovedHandler = function (collection, response) {
  UserStore.trigger('user:shared:sent:calendar:removed', collection, response);
};

UserStore.onSharedCalendarRemovedError = function (collection, response) {
  UserStore.trigger('user:shared:sent:calendar:error', response);
};

UserStore.onSharedCalendarSentHandler = function (collection, response) {
  UserStore.trigger('user:shared:sent:calendar:success', response);
};

UserStore.onSharedCalendarSentError = function (collection, response) {
  UserStore.trigger('user:shared:sent:calendar:error', collection, response);
};

UserStore.onPasswordResetSuccess = function (collection, response) {
  UserStore.trigger('user:reset:password:success', collection, response);
};

UserStore.onPasswordResetError = function (collection, error) {
  UserStore.trigger('user:reset:password:error', error);
};
